// The organization's shared folder shows up as a root-level folder in the dashboard, but its
// contents live in `organizations/{orgId}/modelDir/directory`, not in the personal directory.
//
// It is keyed with a prefix rather than the bare orgId because the legacy share fan-out
// (shareModelWithOrgMembers) still writes a personal folder keyed by orgId. Both can exist at once.
// Firestore auto-ids are 20 alphanumeric characters, so the hyphen alone rules out a collision.
const ORG_FOLDER_PREFIX = "org-";

export const getOrgRootFolderId = (orgId) => `${ORG_FOLDER_PREFIX}${orgId}`;

export const isOrgRootFolderId = (folderId) => typeof folderId === "string" && folderId.startsWith(ORG_FOLDER_PREFIX);

export const getOrgIdFromFolderId = (folderId) =>
    isOrgRootFolderId(folderId) ? folderId.slice(ORG_FOLDER_PREFIX.length) : null;
